module.exports = __webpack_public_path__ + "img/maid.3acced97.svg";